const { isEmpty } = require('lodash');
const { isMultibyte, isEmail, } = require('validator');

const { entries } = Object;

const fields = {
  displayName: {
    type: 'string',
    label: '名前',
    validations: {
      required: v => !isEmpty(v),
    },
  },
  nameKana: {
    type: 'string',
    label: '名前（フリガナ）',
    validations: {
      required: v => !isEmpty(v),
    },
  },
  tenantName: {
    type: 'string',
    label: '会社名',
    validations: {
      required: v => !isEmpty(v),
    },
    hint: '個人事業主の場合は屋号名またはショップ名をお願いします。',
  },
  email: {
    type: 'string',
    label: 'メールアドレス',
    validations: {
      required: v => !isEmpty(v),
      format: v => !v || isEmail(v),
      notMultibyte: v => !v || !isMultibyte(v),
    },
    placeholder: 'mail@example.com',
  },
  phone: {
    type: 'string',
    label: '電話番号',
    validations: {
      required: v => !isEmpty(v),
      format: v => !v || v.match(/^(0{1}\d{9,10})$/),
    },
    placeholder: '08012345678 （ハイフンなし）',
  },
  password: {
    type: 'password',
    label: 'パスワード',
    validations: {
      required: v => !isEmpty(v),
      minLength: v => (v || '').length >= 6,
    },
    placeholder: '6文字以上',
  },
  currentPassword: {
    type: 'password',
    label: '現在のパスワード',
    validations: {
      required: v => !isEmpty(v),
    },
  },
  passwordConfirmation: {
    type: 'password',
    label: 'パスワード確認',
    validations: {
      required: (v, { password }) => !isEmpty(v),
      samePassword: (v, { password }) => v === password,
    },
  },
};

const fieldsToSignIn = {
  email: {
    type: 'string',
    label: 'メールアドレス',
    validations: {
      required: v => !isEmpty(v),
      format: v => !v || isEmail(v),
      notMultibyte: v => !v || !isMultibyte(v),
    },
  },
  password: {
    type: 'password',
    label: 'パスワード',
    validations: {
      required: v => !isEmpty(v),
    },
  }
};

const fieldsToSignUp = {
  email: fields.email,
  password: fields.password,
};

const fieldsToActivate = {
  displayName: fields.displayName,
  nameKana: fields.nameKana,
  tenantName: fields.tenantName,
  phone: fields.phone,
};

exports.fieldsToSignIn = fieldsToSignIn;
exports.fieldsToSignUp = fieldsToSignUp;
exports.fieldsToActivate = fieldsToActivate;
exports.fields = fields;
